import React from "react";
import { useSelector } from "react-redux";
import { Geographies, GeographyProps } from "react-simple-maps";
import { RootState } from "../../../../store/store";
import { GeoMap } from "./GeoMap";

const GeoMapContainer: React.FC = () => {
  const { data: geography } = useSelector((state: RootState) => state.mapApi);
  const { data: stateGeography } = useSelector((state: RootState) => state.stateMap);
  const {
    map: { selectedState },
    countriesPerUser: { data: countries },
  } = useSelector((state: RootState) => state);

  // When a state is selected but county data hasn't loaded yet, show nothing (avoid rendering national map as counties)
  if (selectedState && !stateGeography) {
    return null;
  }

  const rawGeography = selectedState && stateGeography ? stateGeography : geography;

  if (!rawGeography || !countries) {
    return null;
  }

  // API returns map data as [Topology] array — Geographies expects a Topology object directly
  const activeGeography = Array.isArray(rawGeography) ? rawGeography[0] : rawGeography;

  const renderGeoMap = (geographies: GeographyProps[]) => {
    return <GeoMap geographies={geographies} />;
  };

  return (
    <Geographies geography={activeGeography}>
      {({ geographies }) => renderGeoMap(geographies)}
    </Geographies>
  );
};

export default GeoMapContainer;
